import * as React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { offlineActions, apolloClient } from "configs";
import { useOnline, usePrevious, useToast } from "duck";

const OnlineListener: React.FC = () => {
  const dispatch = useDispatch();

  const toast = useToast();
  const navigate = useNavigate();

  const online = useOnline();
  const prevOnline = usePrevious(online);

  React.useEffect(() => {
    const onlineListener = () => {
      dispatch(offlineActions.setOnline(true));
    };
    const offlineListener = () => {
      dispatch(offlineActions.setOnline(false));
    };

    window.addEventListener("online", onlineListener);
    window.addEventListener("offline", offlineListener);

    return () => {
      window.removeEventListener("online", onlineListener);
      window.removeEventListener("offline", offlineListener);
    };
  }, []);

  React.useEffect(() => {
    if (online && !prevOnline) {
      toast({
        description: "Welcome back! Your offline mode is switched off."
      });
    }
    if (!online && prevOnline) {
      apolloClient.cache.evict({ id: "ROOT_QUERY" });
      if (!window.location.pathname.includes("/cases")) {
        navigate("/cases");
      }
      toast({
        description:
          "You’re now working in offline mode. Some features won’t be available until you reconnect to the internet."
      });
    }
  }, [online, prevOnline, toast]);

  return null;
};

export default OnlineListener;
